export default {
  label: 'Ordenação',
  items: {
    asc: 'Crescente',
    desc: 'Decrescente',
  },
};
